// src/tokens/zIndex.ts
var zIndexTableHeader = 300;
var zIndexModal = 1e3;
var zIndexSearchSuggestionsList = 1024;
var zIndexToast = 99999;
export { zIndexTableHeader, zIndexModal, zIndexSearchSuggestionsList, zIndexToast };